var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-box',{staticClass:"empty-state"},[_c('div',{staticClass:"empty-state-body"},[(_vm.title)?_c('h3',{staticClass:"empty-state-title"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }